module.exports = __webpack_public_path__ + "static/media/ibm_logo.d3fccbe1.png";